import React from 'react';
import {Tooltip} from '@mui/material';
import type {PartValueRenderer} from 'schema/types';
import type {ProductOwner as ProductOwnerApiType} from 'services/metadata/types';

export const ProductOwner: PartValueRenderer = ({value}) => {
  if (value && (value as ProductOwnerApiType).code) {
    if ((value as ProductOwnerApiType).name) {
      return (
        <Tooltip title={(value as ProductOwnerApiType).code}>
          <span>{(value as ProductOwnerApiType).name}</span>
        </Tooltip>
      );
    }
    return <span>{(value as ProductOwnerApiType).code}</span>;
  }

  return null;
};
